/**
 * @voltxampere/ui — 7805 +5V fixed linear regulator (Sprint 40-1)
 *
 * Generation-defining TO-220 linear regulator. Reuses the dc-source
 * SVG; the canonical engine type is `voltage-source` so the Sprint 4
 * vdc stamp consumes the 5 V output without engine touch.
 *
 * Inspector / sidebar UI surfaces the datasheet (V_in 7-25 V, I_max
 * 1 A, V_dropout 2 V) when the warning layer ships in Sprint 41+.
 *
 * Reference: Fairchild MC7805. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulator7805 = {
    id: "7805",
    nameTr: "7805 (+5V Sabit, TO-220)",
    nameEn: "7805 (+5V Fixed, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "7805",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-7805.js.map